import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'event-ticker',
    templateUrl: './event-ticker.component.html',
    styles: [`
        .ticker-wrap {
            width: 100%;
            overflow: hidden;
            height: 24px;
            display: flex;
            align-items: center;
        }
        .ticker {
            display: inline-block;
            white-space: nowrap;
            animation: ticker 80s linear infinite;
        }
        .ticker__item {
            display: inline-block;
            padding: 0 3rem;
        }
        @keyframes ticker {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(-50%);
            }
        }
    `],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [NgFor, NgIf, NgClass],
})
export class EventTickerComponent implements OnInit {
    events: any[] = [
        { message: 'New Trip Created', detail: '#TRP-8829 for user Vinay Gupta', time: 'Just now', dotColor: 'bg-blue-500', textColor: 'text-blue-500' },
        { message: 'Trip Started', detail: '#TRP-8812, Driver Amit reached Sector 18 pickup', time: '3 mins ago', dotColor: 'bg-amber-500', textColor: 'text-amber-500' },
        { message: 'Trip Completed', detail: '#TRP-8798, passenger dropped at Golf Course Road', time: '12 mins ago', dotColor: 'bg-green-500', textColor: 'text-green-500' },
        { message: 'Payment Success', detail: '₹640 received for #TRP-8790 via HDFC Card', time: '25 mins ago', dotColor: 'bg-teal-500', textColor: 'text-teal-500' },
        { message: 'New Driver Online', detail: 'Ramesh Kumar (DL-1XY-1234) joined the fleet', time: '40 mins ago', dotColor: 'bg-purple-500', textColor: 'text-purple-500' }
    ];

    constructor() {}

    ngOnInit(): void {}
}
